import React from "react";
import { eurIt as eur } from "@/lib/api";

export const InvoiceLines = ({ inv, prefix }) => (
  <div data-testid={`${prefix}-lines-${inv.id}`}>
    <p className="text-xs font-semibold mb-1" data-testid={`${prefix}-subject-${inv.id}`}>Utilizzo servizi MarkooPlace · {inv.label || inv.month}</p>
    <p className="md:hidden text-xs mb-1" data-testid={`${prefix}-summary-${inv.id}`}>Lordo {eur(inv.total)} · IVA {eur(inv.vat_total)} · Imponibile {eur(inv.net_total)}</p>
    <div className="overflow-x-auto">
    <table className="w-full text-xs min-w-[620px]">
      <thead className="text-muted-foreground"><tr className="text-left">
        <th className="py-1 font-medium">Servizio</th><th className="py-1 font-medium text-right pr-4">Q.tà</th><th className="py-1 font-medium">Trattamento</th>
        <th className="py-1 font-medium text-right">Lordo</th><th className="py-1 font-medium text-right">IVA %</th>
        <th className="py-1 font-medium text-right">IVA €</th><th className="py-1 font-medium text-right">Imponibile</th>
      </tr></thead>
      <tbody>
        {inv.lines.map((l) => <tr key={l.key} className="border-t border-border" data-testid={`${prefix}-line-${inv.id}-${l.key}`}>
          <td className="py-1">{l.label}</td><td className="py-1 text-right pr-4" data-testid={`${prefix}-qty-${inv.id}-${l.key}`}>{l.count ?? "—"}</td><td className="py-1 text-muted-foreground">{l.treatment_label}</td>
          <td className="py-1 text-right">{eur(l.gross)}</td><td className="py-1 text-right">{l.vat_rate}%</td>
          <td className="py-1 text-right">{eur(l.vat_amount)}</td><td className="py-1 text-right">{eur(l.net)}</td>
        </tr>)}
        <tr className="border-t border-border font-semibold" data-testid={`${prefix}-totals-${inv.id}`}>
          <td className="py-1">Totale</td><td className="py-1 text-right pr-4" data-testid={`${prefix}-qty-total-${inv.id}`}>{inv.lines.reduce((n, l) => n + (l.count || 0), 0)}</td><td />
          <td className="py-1 text-right">{eur(inv.total)}</td><td />
          <td className="py-1 text-right">{eur(inv.vat_total)}</td><td className="py-1 text-right">{eur(inv.net_total)}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
);
